/* src/app/core/components/date-picker/date-picker.component.scss */
.date-picker {
  padding: 25px;
  position: absolute;
  left: 50%;
  max-width: 340px;
  transform: translate(-50%, -50%);
  background: white;
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 20px;
  top: 45.5%;
  height: 79%;
}
.buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-size: 20px;
  font-weight: bold;
  color: #1289ad;
}
/*# sourceMappingURL=date-picker.component.css.map */
